var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminFilterSvG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1700 4729 c-253 -65 -473 -271 -586 -549 -149 -367 -109 -810 101 -1126 193 -290 492 -429 793 -369 124 25 266 101 366 196 221 209 336 493 336 829 0 325 -112 614 -317 815 -193 190 -453 267 -693 204z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3540 2710 c-522 -48 -846 -161 -822 -286 15 -80 163 -257 390 -466 181 -167 435 -426 493 -503 l41 -55 27 -463 c30 -515 27 -498 105 -540 57 -30 231 -32 289 -3 70 35 68 26 99 490 15 232 27 442 28 467 0 33 8 58 30 91 48 73 227 254 449 457 343 314 433 418 447 523 5 38 3 48 -21 76 -69 82 -307 155 -645 198 -146 18 -759 28 -910 14z m675 -90 c457 -34 770 -135 684 -221 -45 -45 -197 -88 -406 -113 -665 -82 -1573 2 -1573 145 0 79 322 163 740 192 112 8 428 6 555 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940 2519 c-62 -11 -157 -53 -226 -100 -66 -45 -245 -220 -317 -309 -142 -176 -279 -427 -353 -645 -32 -95 -37 -123 -38 -205 -1 -87 1 -99 27 -143 53 -89 152 -135 376 -172 181 -31 169 -27 496 -135 436 -143 581 -165 1037 -157 388 6 523 31 918 166 214 73 299 97 415 116 50 9 126 23 169 32 l79 16 -7 161 c-10 221 -7 216 -237 447 -101 101 -261 258 -356 349 -168 162 -295 314 -329 395 -7 19 -14 64 -14 100 0 36 -2 65 -5 65 -2 0 -46 -19 -97 -41 -265 -118 -502 -163 -726 -140 -171 18 -271 48 -552 164 -95 39 -175 50 -260 36z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminFilterSvG);
export default __webpack_public_path__ + "static/media/AdminFilterSvG.30f25721e25f1627caebea5ad02f677d.svg";
export { ForwardRef as ReactComponent };